import "../../../shared/client/jst.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.ProviderWidget ??= {};
window.AppointmentBooking.ProviderWidget.Views ??= {};

AppointmentBooking.ProviderWidget.Views.AddressSelector = class AddressSelector extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
  }

  handleAddressSelected(event) {
    return this.$el.trigger(
      AppointmentBooking.ProviderWidget.Events.AddressSelector.addressSelected,
      jQuery(event.currentTarget).data("address-id"),
    );
  }

  handleChangeLocationTrigger(event) {
    event.preventDefault();
    event.stopPropagation();
    this.$el.find(".select-location").addClass("active");
    return jQuery(window).one("click", () => this.$el.find(".select-location").removeClass("active"));
  }

  render() {
    let content = window.Sparkle.Client.jstTemplate(this.template)({
      selectedAddress: this.model.get("selectedAddress").toJSON(),
      addresses: this.model.get("addresses").toJSON(),
    });

    content = jQuery("<form>").html(content); // Wrapping content in a form element will scope input names to this form so radiobuttons in copies of this widget won't interfere with each other
    this.$el.html(content);

    return this;
  }
};
AppointmentBooking.ProviderWidget.Views.AddressSelector.prototype.template =
  "appointment_booking/provider_widget/templates/address_selector";

AppointmentBooking.ProviderWidget.Views.AddressSelector.prototype.events = {
  'click [data-appointment-booking-provider-widget-behaviour="select-address"]': "handleAddressSelected",
  "click .select-location-trigger": "handleChangeLocationTrigger",
};
